// Cover both participant credentials and privileged identity evidence.
export function isIdentitySensitiveUrl(url: string): boolean {
  return /\/(?:public\/identity|admin\/cases|api\/admin\/cases)(?:\/|\?|$)/.test(url);
}
